
      var _path, _circle, _circle2, _path2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCoockies = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 120,
  height: 120,
  viewBox: "0 0 120 120",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M54.506 15.533c.483-.059.962.118 1.42.68.488.599.82 1.508.821 2.434.004 3.227.95 6.394 3.003 8.956 2.066 2.578 5.137 4.397 9.116 5.101.124.022.214.044.28.064a.608.608 0 0 1 .08.029c.462.254.594.464.647.575.065.138.132.393.088.894-.045.514-.193 1.148-.439 1.966-.275.919-.515 1.583-.859 2.696-.601 1.944-1.219 4.347-.955 6.904.274 2.656 1.474 5.284 4.123 7.711 4.315 3.952 9.55 3.973 13.302 3.524a50.626 50.626 0 0 0 2.595-.392c.752-.13 1.34-.234 1.832-.297.896 2.66 1.93 4.62 3.149 5.96 1.457 1.603 3.16 2.29 4.935 2.218 1.615-.066 3.051-.757 4.1-1.341.534-.297 1.067-.626 1.484-.875.451-.27.785-.459 1.056-.581.275-.124.413-.192.509-.236C104.513 85.951 84.629 104.8 60 104.8c-24.742 0-44.8-20.058-44.8-44.8 0-22.882 17.156-41.76 39.306-44.467Z",
  stroke: "#000",
  strokeWidth: 4.4
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 60.5,
  cy: 83.5,
  r: 4.5,
  fill: "var(--theme-primary, #810ea9)"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 54.5,
  cy: 60.5,
  r: 4.5,
  fill: "var(--theme-primary, #810ea9)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M42.567 71.941a5 5 0 1 1 0 10 5 5 0 0 1 0-10ZM44.567 37.941a5 5 0 1 1 0 10 5 5 0 0 1 0-10ZM81.567 72.941a5 5 0 1 1 0 10 5 5 0 0 1 0-10ZM84.567 37.941a5 5 0 1 1 0 10 5 5 0 0 1 0-10Z",
  stroke: "#000",
  strokeWidth: 3
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 84.5,
  cy: 21.5,
  r: 4.5,
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"120\" height=\"120\" viewBox=\"0 0 120 120\" fill=\"none\">\r\n  <path d=\"M54.5059 15.5332C54.9888 15.4742 55.4676 15.6512 55.9268 16.2139C56.4144 16.8116 56.7458 17.7206 56.7471 18.6475C56.7514 21.8737 57.6973 25.0409 59.75 27.6025C61.8161 30.1809 64.8874 32.0002 68.8662 32.7041C68.9899 32.726 69.0797 32.7476 69.1455 32.7676C69.1972 32.7833 69.2216 32.7945 69.2266 32.7969C69.6883 33.0511 69.8205 33.2608 69.873 33.3721C69.9381 33.5097 70.0047 33.7654 69.9609 34.2656C69.9159 34.78 69.768 35.4142 69.5225 36.2324C69.2469 37.1509 69.0074 37.8145 68.6631 38.9277C68.0617 40.8722 67.4442 43.2746 67.708 45.832C67.9821 48.4884 69.1819 51.1164 71.8311 53.543C76.146 57.4951 81.3804 57.5162 85.1328 57.0674C86.0814 56.9539 86.9649 56.8059 87.7275 56.6748C88.4801 56.5455 89.0679 56.4413 89.5596 56.3779C90.4561 59.0385 91.49 60.9985 92.709 62.3389C94.166 63.9409 95.8697 64.628 97.6445 64.5557C99.2586 64.4898 100.695 63.7992 101.744 63.2148C102.278 62.9176 102.811 62.589 103.228 62.3398C103.679 62.0695 104.013 61.8812 104.284 61.7588C104.559 61.6348 104.697 61.5671 104.793 61.5234C104.513 85.9507 84.629 104.8 60 104.8C35.2576 104.8 15.2002 84.7424 15.2002 60C15.2002 37.1183 32.3562 18.2403 54.5059 15.5332Z\" stroke=\"#000000\" stroke-width=\"4.4\"/>\r\n  <circle cx=\"60.5\" cy=\"83.5\" r=\"4.5\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n  <circle cx=\"54.5\" cy=\"60.5\" r=\"4.5\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n  <path d=\"M42.5674 71.9414C45.3288 71.9414 47.5674 74.18 47.5674 76.9414C47.5674 79.7028 45.3288 81.9414 42.5674 81.9414C39.806 81.9414 37.5674 79.7028 37.5674 76.9414C37.5674 74.18 39.806 71.9414 42.5674 71.9414Z\" stroke=\"#000000\" stroke-width=\"3\"/>\r\n  <path d=\"M44.5674 37.9414C47.3288 37.9414 49.5674 40.18 49.5674 42.9414C49.5674 45.7028 47.3288 47.9414 44.5674 47.9414C41.806 47.9414 39.5674 45.7028 39.5674 42.9414C39.5674 40.18 41.806 37.9414 44.5674 37.9414Z\" stroke=\"#000000\" stroke-width=\"3\"/>\r\n  <path d=\"M81.5674 72.9414C84.3288 72.9414 86.5674 75.18 86.5674 77.9414C86.5674 80.7028 84.3288 82.9414 81.5674 82.9414C78.806 82.9414 76.5674 80.7028 76.5674 77.9414C76.5674 75.18 78.806 72.9414 81.5674 72.9414Z\" stroke=\"#000000\" stroke-width=\"3\"/>\r\n  <path d=\"M84.5674 37.9414C87.3288 37.9414 89.5674 40.18 89.5674 42.9414C89.5674 45.7028 87.3288 47.9414 84.5674 47.9414C81.806 47.9414 79.5674 45.7028 79.5674 42.9414C79.5674 40.18 81.806 37.9414 84.5674 37.9414Z\" stroke=\"#000000\" stroke-width=\"3\"/>\r\n  <circle cx=\"84.5\" cy=\"21.5\" r=\"4.5\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/coockies.55042923c7c127b523f3f64b9850ef9d.svg"),
        {
          React: SvgCoockies,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      